export function useDate(date: string | number): Date {
  // function removes timezone changes for dates, for use with "YYYY-MM-DD" type dates
  const og = new Date(date);
  return new Date(og.valueOf() + og.getTimezoneOffset() * 60 * 1000);
}
